const PortableMore = () => {
  return (
    <div className="bg-gray-200 my-24 relative z-10">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between">
        <h2 className="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
          <span className="block">Ready to dive in?</span>
          <span className="block text-indigo-600">
            Start using SkyGo Portable WiFi today.
          </span>
        </h2>
        <div className="mt-8 flex justify-center lg:mt-0 lg:flex-shrink-0">
          <div className="inline-flex rounded-md shadow">
            <a
              href="https://orders.skygowifi.com/ordersbeta/Index.aspx"
              className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
            >
              Get started
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
export default PortableMore;
